import React from 'react';
import { NavLink } from 'react-router-dom';
import platinaIcon from '../../img/icons/platina-design.png';
import './Header.css';

export default function Header() {
  return (
    <header role="banner">
      <NavLink id="header-nav-link" className="no-underline" to="/">
        <div id="platina-design-header">
          <img loading="lazy" src={platinaIcon} id="platina-design-icon" alt="Platina Design Inc icon" />
          <h1 id="main-header">Platina Design, Inc.</h1>
        </div>
      </NavLink>
      <h3 className="header-description">Certified Graduate Gemologists</h3>
      <h3 className="header-description">Fine Jewelry, Custom Designs</h3>
    </header>
  );
}
